import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import ProfilePhoto from '@contact/components/Add/ProfilePhoto.vue'
import WriteForm from '@contact/components/Add/WriteForm.vue'
import api from '@contact/api'
import { ContactsStoredType } from '../types/enums'
@Component({
  components: { 
    ProfilePhoto,
    WriteForm
  },
})
export default class AddContainer extends Vue {

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  item = ({
    displayName: '',
    surname: '',
    givenName: '',
    email: '',
    companyName: '',
    department: '',
    jobTitle: '',
    officeLocation: '',
    hasPicture: true,
    mobile: '',
    businessPhone: '',
    businessFax: '',
    businessHomePage: '',
    businessAddress: {
      city: '',
      countryOrRegion: '',
      postalCode: '',
      state: '',
      street: '',
    } as contacts.ContactAddresses,
    homeAddress: {
      city: '',
      countryOrRegion: '',
      postalCode: '',
      state: '',
      street: '',
    } as contacts.ContactAddresses,
    deletedDate: '',
    //attachments: [] as any,
    photoPath: '',
    targetPersonCode: '',
    parentFolderId: '',
    //itemClass:
    //storedType:
    isSharing: false,
    isShared: false,
  } as contacts.ContactItem);

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  async save() {
    const item = this.item;
    
    if (item.givenName === '') {
      await(window as any).alertAsync(this.$t('M_Contact_InvalidValueError6').toString());
      return false;
    } else {
      const fields: mail.api.FieldOption[] = [
        { key: 'GivenName', value: item.givenName },
        {
            key: 'DisplayName',
            value: item.surname?.concat(item.givenName),
        },
      ];
      if (item.email) {
        fields.push({
          key: 'EmailAddresses',
          indexedKey: 'EmailAddress1',
          value: item.email,
        });
      }
      if (item.surname) {
        fields.push({ key: 'Surname', value: item.surname });
      }
      if (item.mobile) {
        fields.push({
          key: 'PhoneNumbers',
          indexedKey: 'MobilePhone',
          value: item.mobile,
        });
      }
      if (item.companyName) {
        fields.push({ key: 'CompanyName', value: item.companyName });
      }
      if (item.department) {
        fields.push({ key: 'Department', value: item.department });
      }
      if (item.jobTitle) {
        fields.push({ key: 'JobTitle', value: item.jobTitle });
      }
      if (item.businessPhone) {
        fields.push({
          key: 'PhoneNumbers',
          indexedKey: 'BusinessPhone',
          value: item.businessPhone,
        });
      }
      if (item.businessFax) {
        fields.push({
          key: 'PhoneNumbers',
          indexedKey: 'BusinessFax',
          value: item.businessFax,
        });
      }
      if (item.businessHomePage) {
        fields.push({
          key: 'BusinessHomePage',
          indexedKey: 'BusinessHomePage',
          value: item.businessHomePage,
        });
      }
  
      if (item.businessAddress && item.businessAddress.street) {
        fields.push({
          key: 'PhysicalAddresses',
          indexedKey: 'BusinessAddressStreet',
          value: {
            Street: item.businessAddress.street,
            PostalCode: item.businessAddress.postalCode,
          },
        });
      }
      if (item.homeAddress && item.homeAddress.street) {
        fields.push({
          key: 'PhysicalAddresses',
          indexedKey: 'HomeAddressStreet',
          value: {
            Street: item.homeAddress.street,
            PostalCode: item.homeAddress.postalCode,
          },
        });
      }
      if (item.officeLocation) {
          fields.push({ key: 'OfficeLocation', value: item.officeLocation });
      }
      const data: mail.api.DynamicApiOptions = {
        fields: fields,
        parentId: item.parentFolderId,
        type: 'Contact',
      };

      api.contact.createContact(data, ContactsStoredType.EWS).then((res) => {
        if (res) {
          this.$router.push('/contact/list')
        }
      })
      .catch(async (err) => {
          console.log('addcontact error', err);
          if (err.type === 'DuplicateNameException') {
              await(window as any).alertAsync(this.$t('M_Contact_DuplicateContact2').toString());
              return Promise.reject(err);
          }
      });
    }
  }

  created() {
    api.personal.getBasicContactFolder().then((res) => {
      this.item.parentFolderId = res[0].id
    })
  }
}
